import React, { useMemo } from 'react';
import { DocumentORM, DocumentVersionORM, AssociatedFileORM, ORMTypes } from 'src/types/types';
import { DNAChipProps } from '@alucio/lux-ui';
import { DNAChip } from 'src/components/DNA';

type DNAFileTypeChipVariant = 'DEFAULT' | 'THUMBNAIL';

interface DNAFileTypeChipProps extends DNAChipProps {
  orm?: DocumentVersionORM | DocumentORM | AssociatedFileORM;
  variant?: DNAFileTypeChipVariant;
}

const getFileTypeDisplay = (orm?: DocumentVersionORM | DocumentORM | AssociatedFileORM): string | undefined => {
  if (!orm) return undefined;
  const type = orm.type === ORMTypes.ASSOCIATED_FILE ? orm.file?.type : orm.model?.type;
  return type?.toUpperCase() === 'MP4' ? 'VIDEO' : type;
};

const variantConfigs: Record<DNAFileTypeChipVariant, Partial<DNAChipProps>> = {
  DEFAULT: {
    testID: 'file-type-badge',
    appearance: 'outline',
    status: 'secondary',
  },
  THUMBNAIL: {
    testID: 'file-type-thumbnail-badge',
    appearance: 'filled',
    status: 'transparent',
  },
}

/**
 * Beacon-specific DNAChip component for document file type
 */
export const DNAFileTypeChip: React.FC<DNAFileTypeChipProps> = ({
  orm,
  variant = 'DEFAULT',
  ...rest
}) => {
  const chipText = useMemo(() => getFileTypeDisplay(orm), [orm]);
  const config = useMemo(() => variantConfigs[variant], [variant]);

  if (!chipText) return null;
  return (
    <DNAChip.Beacon
      {...config}
      children={chipText}
      {...rest}
    />
  );
};

export default DNAFileTypeChip;
